import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header2';
import CheckoutProgress from '../../components/ui/CheckoutProgress';
import OrderSuccessHeader from './components/OrderSuccessHeader';
import DeliveryInfo from './components/DeliveryInfo';
import OrderSummary from './components/OrderSummary';
import PaymentInfo from './components/PaymentInfo';
import EmailConfirmation from './components/EmailConfirmation';
import ActionButtons from './components/ActionButtons';
import AccountCreationPrompt from './components/AccountCreationPrompt';
import RecommendedProducts from './components/RecommendedProducts';
import OrderTrackingInfo from './components/OrderTrackingInfo';

const OrderConfirmation = () => {
  const location = useLocation();
  
  // Mock order data - in real app this would come from state/API
  const orderData = {
    orderNumber: "ORD-2025-001234",
    orderDate: "January 20, 2025",
    estimatedDelivery: "January 25, 2025",
    customerEmail: "john.doe@email.com",
    isGuestUser: true,
    shippingAddress: {
      name: "John Doe",
      street: "123 Main Street, Apt 4B",
      city: "New York",
      state: "NY",
      zipCode: "10001",
      country: "United States",
      phone: "+1 (555) 123-4567"
    },
    billingAddress: {
      name: "John Doe",
      street: "123 Main Street, Apt 4B",
      city: "New York",
      state: "NY",
      zipCode: "10001",
      country: "United States"
    },
    paymentMethod: {
      type: "Visa",
      lastFour: "4242"
    },
    orderItems: [
      {
        id: 1,
        name: "Premium Wireless Headphones",
        variant: "Black, Over-Ear",
        quantity: 1,
        price: 199.99,
        originalPrice: 249.99,
        image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=150&h=150&fit=crop"
      },
      {
        id: 2,
        name: "Smartphone Case",
        variant: "Clear, iPhone 15 Pro",
        quantity: 2,
        price: 24.99,
        originalPrice: 29.99,
        image: "https://images.unsplash.com/photo-1601593346740-925612772716?w=150&h=150&fit=crop"
      },
      {
        id: 3,
        name: "USB-C Charging Cable",
        variant: "3ft, White",
        quantity: 1,
        price: 15.99,
        originalPrice: null,
        image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=150&h=150&fit=crop"
      }
    ],
    orderTotal: {
      subtotal: 264.97,
      shipping: 0,
      tax: 21.20,
      discount: 25.00,
      total: 261.17
    }
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Set page title
    document.title = `Order Confirmation - ${orderData.orderNumber}  `;
  }, [orderData.orderNumber]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {/* Checkout Progress */}
      <div className="pt-16">
        <CheckoutProgress currentStep={3} />
      </div>
      
      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Success Header */}
        <OrderSuccessHeader 
          orderNumber={orderData.orderNumber}
          orderDate={orderData.orderDate}
        />
        
        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column */}
          <div className="space-y-6">
            <DeliveryInfo 
              estimatedDelivery={orderData.estimatedDelivery}
              shippingAddress={orderData.shippingAddress}
            />
            
            <PaymentInfo 
              paymentMethod={orderData.paymentMethod}
              billingAddress={orderData.billingAddress}
            />
            
            <EmailConfirmation 
              customerEmail={orderData.customerEmail}
            />
          </div>
          
          {/* Right Column */}
          <div className="space-y-6">
            <OrderSummary 
              orderItems={orderData.orderItems}
              orderTotal={orderData.orderTotal}
            />
            
            <OrderTrackingInfo 
              orderNumber={orderData.orderNumber}
            />
          </div>
        </div>
        
        {/* Full Width Sections */}
        <div className="mt-8 space-y-6">
          <AccountCreationPrompt 
            isGuestUser={orderData.isGuestUser}
            customerEmail={orderData.customerEmail}
          />
          
          <ActionButtons 
            orderNumber={orderData.orderNumber}
          />
          
        {/*  <RecommendedProducts />*/}
        </div>
      </main>
      
      {/* Footer Spacer */}
      <div className="h-16"></div>
    </div>
  );
};

export default OrderConfirmation;